import React from 'react';
import classNames from 'classnames';

import styles from './LoadingCircle.module.scss';

export interface LoadingCircleProps {
  size?: number;
  thickness?: number;
  color?: 'primary' | 'secondary' | 'white';
  className?: string;
}

const LoadingCircle: React.FC<LoadingCircleProps> = ({
  size = 24,
  thickness = 3,
  color = 'primary',
  className,
}) => {
  return (
    <span
      className={classNames(styles.loadingCircle, styles[color], className)}
      style={{ width: `${size}px`, height: `${size}px`, borderWidth: `${thickness}px` }}
      role="status"
      aria-label="Loading"
    />
  );
};

export default LoadingCircle;
